module.exports = __webpack_public_path__ + "img/steps2.42b5a9c6.svg";